import { createContext } from 'react';

import { CampaignCountryMetadata } from '@features/campaigns/shared/providers/CampaignCountryProvider/buildCampaignCountryMetadata.ts';

export const CampaignCountryContext = createContext<CampaignCountryMetadata | undefined>(undefined);
